import { CALL_API } from '../middleware/ApiMiddleware';

export const FETCH_FINES_SETUP_REQUEST = 'FETCH_FINES_SETUP_REQUEST';
export const FETCH_FINES_SETUP_SUCCESS = 'FETCH_FINES_SETUP_SUCCESS';
export const FETCH_FINES_SETUP_FAILURE = 'FETCH_FINES_SETUP_FAILURE';

export const UPDATE_FINES_SETUP_REQUEST = 'UPDATE_FINES_SETUP_REQUEST';
export const UPDATE_FINES_SETUP_SUCCESS = 'UPDATE_FINES_SETUP_SUCCESS';
export const UPDATE_FINES_SETUP_FAILURE = 'UPDATE_FINES_SETUP_FAILURE';

export const CLEAR_FINES_SETUP = 'CLEAR_FINES_SETUP';

const baseURL = 'xerce/config/setup';

export const fetchFinesSetup = () => ({
  [CALL_API]: {
    endpoint: baseURL,
    method: 'get',
    authenticated: true,
    types: [FETCH_FINES_SETUP_REQUEST, FETCH_FINES_SETUP_SUCCESS, FETCH_FINES_SETUP_FAILURE],
  },
});

export const updateFinesSetup = (finesSetup: IFinesSetupRequest) => ({
  [CALL_API]: {
    endpoint: baseURL,
    method: 'put',
    authenticated: true,
    body: finesSetup,
    types: [UPDATE_FINES_SETUP_REQUEST, UPDATE_FINES_SETUP_SUCCESS, UPDATE_FINES_SETUP_FAILURE],
  },
});

export const clearFinesSetup = () => ({
  type: CLEAR_FINES_SETUP,
});
